<template>
	<div class="pcdetails" v-scroll:throttle="{fn: onScroll, throttle: 500 }">
		<el-backtop target=".pcdetails"></el-backtop>
		<div class="sevideot" v-if="setohomevid">
			<div class="sevidecont">
				<video :src="sevideotcon" autoplay="autoplay" controls></video>
				<div class="el-icon-circle-close" @click="seclosevideo"></div>
			</div>
		</div>
		<div class="pchome-headersea">
			<headers @ChangeEmit="ChangeEmit" ref="head"></headers>
		</div>
<!--		<div class="seachheardesea">-->
<!--			&lt;!&ndash; <div class="palseachsisea">-->
<!--				<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phseachsimg/phseachinput.png" />-->

<!--			</div> &ndash;&gt;-->
<!--			<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phseachsimg/phseachinput.png" />-->
<!--			<input @keyup.enter="seachhc()" v-model="seachinput" :placeholder="seaplac " />-->
<!--		</div>-->
		<div class="search-bar">
			<el-autocomplete
					v-model="seachinput"
					:fetch-suggestions="querySearchAsync"
					placeholder=""
					@select="handleSelect"
					prefix-icon="el-icon-search"
					@input="get_hot_search"
					@keydown.enter.native="getDateList('enter')"
					@focus="focusAutocomplete"
			></el-autocomplete>
		</div>
		<div class="productcsea">
			<div class="productcsea-right">
				<div class="right-detail" :class="acindex==1?'cc':''" @click="switchTab(1)">
					{{seaproduct}}
				</div>
				<div class="right-parameter" :class="acindex==2?'cc':''" @click="switchTab(2)">
					{{seavideo}}
				</div>
				<div class="right-instructions" :class="acindex==3?'cc':''" @click="switchTab(3)">
					{{seaquery}}
				</div>
			</div>
		</div>
		<div class="linesd"></div>
		<div class="search-righttex" v-if="acindex==1">
			<div class="rihseach-hea" v-if="lcategoryidlistleng > 0">{{sealeft}} {{lcategoryidlistleng}} {{searight}}</div>
			<div class="rihseach-hea" v-else>No Results</div>
			<div class="rihseach-foo">
				<div class="rihseafoo-cont">
					<div class="riseaacon-item" v-for="(item,index) in lcategoryidlist" :key="index" @click="detailto(item.id)">
						<div class="itempro-img">
							<!--							<img :src="item.rule_image" />-->
							<img :src="item.menu_image" />
						</div>
						<div class="itempro-model">
							{{item.name}}
						</div>
						<div class="itempro-title">
							{{item.name_content}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="parametersea" v-if="acindex==2">
			<div class="rihseach-hea" v-if="videoclassliststtleng > 0">{{sealeft}} {{videoclassliststtleng}} {{searight}}</div>
			<div class="rihseach-hea" v-else>No Results</div>
			<div class="rihseach-foo">
				<div class="rihseafoo-cont">
					<div class="riseaacon-item" v-for="(item,index) in videoclassliststt" :key="index">
						<div class="itempro-imgss">

							<video :src="item.video" :poster="item.image"></video>
							<div class="itemprovid" @click="seachtot(item.video)">
								<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcvideosimg/pvviplay.png" />
							</div>
						</div>
						<div class="itempro-model">
							<div>{{item.title}}</div>
							<div><img @click="download_video(item)"  src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcseachsimg/pceapdown.png"/></div>
						</div>

						<!-- <div class="itempro-title">
							产品名称标题自定义文案
						</div> -->
					</div>
				</div>
			</div>
		</div>
		<div class="search-righttex" v-if="acindex==3">
			<div class="rihseach-hea" v-if="downloadliststlength > 0">{{sealeft}} {{downloadliststlength}} {{searight}}</div>
			<div class="rihseach-hea" v-else>No Results</div>
			<div class="rihseach-foo">
				<div class="rihseafoo-cont">
					<div class="riseaacon-item" v-for="(item,index) in downloadlistst">
						<div class="itempro-img">
							<!--							&lt;!&ndash;							<img :src="item.image" />&ndash;&gt;-->
							<img :src="item.image" />
						</div>
						<div class="itempro-title">
							{{item.title}}
						</div>
						<div class="servicecontsea" >
							<div  class="servritit"><span style="border-bottom: 2px solid #D03E3D;" @click="navtoshiyan(item.file)">{{onlinepreview}}</span></div>

							<img @click="dolofle(item)"  src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcseachsimg/pceapdown.png"/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div ref="bottom" style="width: 100%;height: 50px;"></div>
		<footers ref=is_change></footers>

	</div>
</template>

<script>
	import 'lib-flexible/flexible.js'
	import {session} from '../../storage/storage.js';
	import headers from '../../common/header.vue'
	import footers from '../../common/footers.vue'
	export default{
		data(){
			return{
				id:'',
				setohomevid:false,
				seaplac:'',
				seaproduct:'product',
				seavideo:'video',
				seaquery:'query',
				sealeft:'搜到',
				searight:'条结果',
				onlinepreview:'在线预览',
				sevideotcon:'',
				navheader:true,
				heshow:false,
				show: false,
				playli:true,
				playri:true,
				acindex:1,
				seachinput:'',
				lcategoryidlist:[],
				videoclassliststt:'',
				lcategoryidlistleng:0,
				videoclassliststtleng:0,
				filearr:[],
				downloadlistst:[],
				downloadliststlength:0,
				options: [],
				optionslang: [],
				value: '',
				valuelang: '',
				list_img: [],
				pageSize:12,
				page:0,
				load:true,
				// start:false,
				totalPage:0,
				restaurants: [],
				subSearch:false,
				elAutocompleteSuggestion:''
			}
		},
		components:{
			headers,
			footers
		},
		created() {
			// this.value=this.options[0].label
			// this.valuelang=this.optionslang[0].labellang
			this.getParams()
			/* this.pcchannelcategoryidlist() */
			// this.pcdownloadlist()
			this.heshow=true
		},
		watch:{
			'$route': 'getParams'
		},
		mounted() {
			document.addEventListener('scroll',this.handleScroll,false)
			this.$once('hook:beforeDestroy', () => {
				document.removeEventListener('scroll', this.handleScroll,false)
			})
			this.elAutocompleteSuggestion = document.getElementsByClassName('el-autocomplete-suggestion')[0]
			this.get_hot_search()
			this.getDateList('enter')

		},
		methods: {
			get_hot_search(){
				this.elAutocompleteSuggestion.classList.remove('hidden-el-autocomplete-suggestion')
				if(this.subSearch){
					return
				}
				this.subSearch = true
				let _this =  this,lang = session.get('lang')
				_this.restaurants = []
				_this.$api.get_hot_search({
					lang,
					type:_this.acindex,
					keyword:_this.seachinput,
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
				}).then(res  => {
					res.data.forEach(function (v) {
						_this.restaurants.push({value:v})
					})
					this.subSearch = false
				})
			},
			querySearchAsync(queryString, cb) {
				// var restaurants = this.restaurants;
				// var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
				cb(this.restaurants)
			},
			createStateFilter(queryString) {
				return (seachinput) => {
					return (seachinput.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
				};
			},
			handleSelect(item) {
				this.seachhc()
			},
			focusAutocomplete(){
				this.elAutocompleteSuggestion.classList.remove('hidden-el-autocomplete-suggestion')
			},
			onScroll: function(e, position) {
				if(!this.$utils.isElementNotInViewport(this.$refs.bottom)){
					this.getDateList()
				}
			},
			switchTab(i){
				this.acindex = i

				this.seachinput = ''
				this.get_hot_search()
				this.getDateList('enter')
			},
			// changePage(e){
			// 	this.page = e
			// 	this.getDateList()
			// },
			dolofle(e){
				var name = e.title;
				var url = e.file;
				var suffix = url.substring(url.lastIndexOf("."), url.length);
				//跳过浏览直接下载
				fetch(url)
						.then(res => res.blob())
						.then(blob => {
							const a = document.createElement("a");
							const objectUrl = window.URL.createObjectURL(blob);
							a.download = name;
							a.href = objectUrl;
							a.click();
							window.revokeObjectURL(objectUrl);
						})
			},
			navtoshiyan(e){
				window.open(e)
			},
			download_video(item){
				this.$utils.handleDownloadUri(item.title,item.video)
			},
			ChangeEmit(){ //子组件传递
				//主动调用子组件
				this.$refs.is_change.get_index_channel_data();
				this.$refs.is_change.pageParam();
				this.pageParam()
				this.getParams();
				this.pcdownloadlist()
			},
			seclosevideo(){
				this.setohomevid=false
			},
			seachtot(e){
				this.sevideotcon=e
				this.setohomevid=true
			},
			pageParam(){
				let lang =  session.get("lang");
				if (lang === "cn"){
					// this.seaplac = "请输入"
					this.seaproduct="产品"
					this.seavideo='视频'
					this.seaquery='服务'
					this.sealeft='搜到'
					this.searight='条结果'
					this.onlinepreview='在线预览'

				}else{
					// this.seaplac = "Please enter"
					this.seaproduct="Products"
					this.seavideo='Video'
					this.seaquery='Service'
					this.sealeft='Found'
					this.searight='Results'
					this.onlinepreview='Online Preview'
				}
			},
			getDateList(type=''){
				if(type == 'enter'){
					this.page = 0
					this.lcategoryidlist = []
					this.videoclassliststt = []
					this.downloadlistst = []
					this.lcategoryidlistleng = 0
					this.videoclassliststtleng = 0
					this.downloadliststlength = 0
					this.elAutocompleteSuggestion.classList.add('hidden-el-autocomplete-suggestion')

				}

				if(this.totalPage != 0 && this.totalPage <= this.page){
					return
				}
				this.page++
				if(this.acindex == 1){
					this.pcchannelcategoryidlist()
				}else if(this.acindex == 2){
					this.videoclasslist()
				}else if (this.acindex == 3){
					this.pcdownloadlist()
				}
			},
			seachhc(){
				this.getDateList('enter')

			},
			handleDownload(){
				let arr=[]
				this.filearr=[]

				if (this.seachinput) {
					arr = this.downloadlistst.filter(item => item.title.includes(this.seachinput))

					/* this.filearr.push(arr) */
					this.filearr=arr
					this.downloadliststlength=this.filearr.length

				}
			},
			pcchannelcategoryidlist(){ //产品搜索内容
				let data={
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
					page:this.page,
					pageSize:this.pageSize,
					mold:"pc",
					keyword:this.seachinput
				}
				this.$api.get_product_list(data).then((res) => {
					this.lcategoryidlist=this.lcategoryidlist.concat(res.data.data)
					this.lcategoryidlistleng=res.data.total
					this.totalPage = Math.ceil(res.data.total/this.pageSize)
				});
			},
			videoclasslist(){ //视频搜索内容
				let data={
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
					mold:'pc',
					page:this.page,
					pageSize:this.pageSize,
					keyword:this.seachinput
				}
				this.$api.get_video_list(data).then((res) => {
					this.videoclassliststt=this.videoclassliststt.concat(res.data.data)
					this.videoclassliststtleng=res.data.total
					this.totalPage = Math.ceil(res.data.total/this.pageSize)
				});
			},
			detailto(e){
				this.$router.push({path: '/pcdetails',query:{e,type:'pc'}})
			},
			pcdownloadlist(){

				let data={
					/* type_id:this.type_id, */
					mold:'pc',
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
					page:this.page,
					pageSize:this.pageSize,
					keyword:this.seachinput
				}
				this.$api.get_download_list(data).then((res) => {
					this.downloadlistst=this.downloadlistst.concat(res.data.data)
					this.downloadliststlength=res.data.total
					this.totalPage = Math.ceil(res.data.total/this.pageSize)
					// this.handleDownload()
				});
			},
			handleScroll (e) {
				let scrollTop = document.documentElement.scrollTop ||document.body.scrollTop
				this.$refs.head.scrollTop_change(scrollTop)
			},
			nextimg(){
				let l = this.list_img.length;
				let scroll = document.getElementById('scroll-x');
				let diatance = scroll.scrollWidth - scroll.clientWidth;
				if(this.current_index == 0){
					this.current_index = l-1;
					scroll.scrollLeft = diatance;
				}else{
					this.current_index--;
					scroll.scrollLeft -= diatance / (l - 1);
				}
			},
			preimg(){
				let l = this.list_img.length;
				let scroll = document.getElementById('scroll-x');
				let diatance = scroll.scrollWidth - scroll.clientWidth;
				if(this.current_index+1 == l){
					this.current_index = 0;
					scroll.scrollLeft = 0;
				}else{
					this.current_index++;
					scroll.scrollLeft += diatance / (l - 1);
				}
			},
			hometo(){
				this.$router.push({path: '/pchome'})
			},
			videoto(){
				this.$router.push({path: '/pcvideos'})
			},
			queryto(){
				this.$router.push({path: '/pcquerys'})
			},
			productto(){
				this.$router.push({path: '/pcproduct'})
			},
			elitesto(){
				this.$router.push({path: '/pcelites'})
			},
			contactusto(){
				this.$router.push({path: '/pccontactus'})
			},
			aboutto(){
				this.$router.push({path: '/pcabout'})
			},
			enter(index){
				this.navheader= true;
			},
			playenterli(){
				this.playli=false
			},

			playenterri(){
				this.playri=false
			},
			playleaveli(){
				this.playli=true
			},
			playleaveri(){
				this.playri=true
			},
			getParams () {
				this.id = this.$route.query.e
			}

		}
	}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
		background: #fff;
	}
	.pcdetails{
		width: calc(100vw);
		height: calc(100vh);
		overflow-x: hidden;
		position: relative;
		background: #fff;
	}
	.pchome-headersea{
		width: 100vw;
		position: relative;
		background-size: 100% 100%;
		padding-top: 79px;
		box-sizing: border-box;
	}

	.checse{
		margin-top: 0 !important;
	}
	.product-title{
		color: #fff;
		margin-top: 249px;
		margin-left: 240px;
	}
	.title-hea{
		font-size: 20px;
		font-weight: normal;
		letter-spacing: 1px;
	}
	.title-model{
		margin-top: 15px;
		margin-bottom: 15px;
		font-size: 44px;
		font-weight: normal;
		letter-spacing: 2px;
	}
	.product-but{
		margin-top: 40px;
		font-size: 16px;
		width: 110px;
		height: 46px;
		background: #E31E24;
		border-radius: 23px;
		line-height: 46px;
		text-align: center;
		cursor: pointer;
		font-size: 16px;
	}


	.bb{
		background: #FAFAFA;
		position: fixed;
		top: 0;
		z-index: 99;
	}
	.aboutitem-hea{
		margin-top: 80px;
		margin-bottom: 40px;
		height: 33px;
		font-size: 24px;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 33px;
		letter-spacing: 1px;
	}
	.aboutitem-fooitem{
		margin-bottom: 10px;
	}
	.fooitem-left{
		width: 110px;
		height: 32px;
		border-radius: 4px;
		border: 1px solid #EAEAEA;
		display: flex;
		align-items: center;
		justify-content: center;


		font-size: 16px;
		font-weight: 400;
		color: #FAFAFA;
		margin-right: 20px;
	}
	.fooitem-left img{
		width: 16px;
		height: 16px;
		margin-right: 6px;
	}
	.aboutitem-foosus{
		display: flex;
		margin-bottom: 20px;
	}
	.fooitem-right{
		font-size: 16px;
		font-weight: 400;
		color: #CCCCCC;
	}
	.fooitem-cont{
		margin-top: 25px;
		margin-left: 40px;
	}
	.fooitem-cont:first-child{
		margin-left: 0px;
	}
	.fooite-img{
		display: flex;
	}
	.fooite-img img{
		width: 90px;
		height: 90px;
	}
	.fooite-nam{
		text-align: center;
		margin-top: 20px;
	}
	.right-tit{
		margin-bottom: 5px;
	}
	.homefoot{

		height: 94px;
		background: #272727;
		border-top: 2px solid #666;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.foot-hea{
		height: 22px;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		line-height: 22px;
	}
	.foot-f{
		height: 22px;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		line-height: 22px;
		margin-top: 10px;
		margin-bottom: 20px;
	}
	.productcsea{
		width: 1400px;
		height: 80px;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 260px;
	}

	.productcsea-right{
		font-size: 16px;
		font-weight: 400;
		color: #5d5f5f;
		display: flex;
	}
	.right-detail{
		margin-right: 24px;
		cursor: pointer;
	}
	.right-parameter{
		margin-right: 24px;
		cursor: pointer;
	}
	.right-instructions{
		cursor: pointer;
	}
	.linesd{
		width: 100%;
		height: 1px;
		background: #EAEAEA;
	}


	.cc{
		color: #D03E3D;
	}
	.parametersea{
		width: 1400px;
		display: flex;
		flex-direction: column;
		padding: 0px 260px;

	}
	.instructions{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.seachheardesea{
		display: flex;
		align-items: center;
		margin: 0 auto;
		width: 700px;
		height: 60px;
		position: relative;
		margin-top: 85px;
		border-radius: 30px;
		border: 1px solid #CCCCCC;
		background-color: #fff;
	}
	.seachheardesea img{
		width: 22px;
		height: 22px;
		margin-left: 18px;
	}
	.seachheardesea input{
		width: 600px;
		height: 55px;
		margin-left: 16px;
		/* border-radius: 30px;
		border: 1px solid #CCCCCC; */
		border: none;
		font-size: 22px;
		font-weight: 400;
		color: #666666;
		letter-spacing: 1px;
		/* padding-left: 56px; */
		box-sizing: border-box;
	}
	input:focus-visible{
		outline: none;
	}
	input-placeholder{
		font-size: 22px;
		font-weight: 400;
		color: #666666;
		letter-spacing: 1px;
	}
	.palseachsisea{
		margin-left: 24px;
		margin-right: 12px;
		width: 22px ;
	}
	.palseachsisea img{
		width: 22px;
		height: 22px;
	}
	.search-righttex{
		width: 1400px;
		display: flex;
		flex-direction: column;
		padding: 0px 260px;
	}
	.rihseach-hea{
		margin-top: 20px;
		margin-bottom: 20px;
		font-size: 16px;
	}
	.rihseach-foo{


	}
	.search-righttex{
		display: flex;
	}
	.rihseafoo-cont{
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}
	.riseaacon-item{
		width: 320px;
		margin-right: 25px;
		margin-bottom: 25px;
		cursor: pointer;
		font-size: 16px;
	}
	.riseaacon-item:nth-child(4n){
		/*margin-right: 0px;*/
	}
	.itempro-img{
		width: 320px;
		height: 320px;
		overflow: hidden;
		border-radius: 6px;
	}
	.itempro-imgss{
		width: 320px;
		height: 320px;
		position: relative;
	}
	/* .itempro-imgss img{
		width: 100%;
		height: 100%;
	} */
	.itempro-imgss video{
		width: 320px;
		height: 320px;
	}
	.itemprovid{
		position: absolute;
		top: 140px;
		left: 140px;
		width: 40px;
		height: 40px;
	}
	.itemprovid img{
		width: 100%;
		height: 100%;
	}
	/*.itempro-img:hover img{*/
	/*	cursor: pointer;*/
	/*	width: 320px;*/
	/*	height: 320px;*/
	/*}*/
	.itempro-img img{
		cursor: pointer;
		border-radius: 6px;
		width: 100%;
		transition: all .75s linear;
	}
	.itempro-img img:hover{
		transform: scale(1.02);
	}
	.itempro-img video{
		width: 100%;
		height: 100%;
	}
	.instructions{
		width: 1400px;
		display: flex;
		flex-direction: column;
		padding: 0px 260px;
	}
	.servicecontsea{
		display: flex;
		align-items: center;
		margin-top: 15px;
	}
	.servritit{
		/* width: 60px; */
		height: 20px;
		font-size: 14px;
		font-weight: 400;
		color: #D03E3D;
		line-height: 20px;
		cursor: pointer;
		display: flex;
		align-items: center;
	}
	.servicecontsea img{
		margin-left: 8px;
		width: 20px !important;
		height: 20px !important;
		margin-bottom: -4px;
		cursor: pointer;
	}
	.itempro-model{
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 15px;
	}
	.itempro-model img{
		height: 20px;
		width: 20px;
		cursor: pointer;
	}
	.itempro-title{
		margin-top: 10px;
	}

	.sevideot{
		width: 100vw;
		height: 100vh;
		background: rgba(0,0,0,.32);
		position: fixed;
		top: 0px;
		z-index: 1000;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.sevidecont{
		position: relative;
		width: 1200px;
		height: 600px;
	}
	.sevidecont video{
		width: 1200px;
		height: 600px;
	}
	.el-icon-circle-close{
		font-size: 40px;
		color: #fff;
		position: absolute;
		top: -20px;
		right: -16px;
		cursor: pointer;
	}
	.head_background {
		background-color: #FFFFFF;
	}
	.search-bar {
		width: 800px;
		margin: 0 auto;
	}
	.search-bar .el-autocomplete {
		width: 100%;
	}
	.search-bar .el-autocomplete .el-input__inner:focus {
		border: 1px solid #DCDFE6;
	}
	.search-bar .el-autocomplete .el-input input{
		border-radius: 50px;
	}
	.hidden-el-autocomplete-suggestion {
		display: none;
	}
</style>
